import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const challengesImageChoiceViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map